"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forBytecode = exports.forContract = void 0;

function forContract(contract) {
  var contractName = contract.contractName,
      sourcePath = contract.sourcePath,
      source = contract.source,
      sourceMap = contract.sourceMap,
      deployedSourceMap = contract.deployedSourceMap,
      legacyAST = contract.legacyAST,
      ast = contract.ast,
      abi = contract.abi,
      metadata = contract.metadata,
      bytecode = contract.bytecode,
      deployedBytecode = contract.deployedBytecode,
      compiler = contract.compiler,
      devdoc = contract.devdoc,
      userdoc = contract.userdoc,
      immutableReferences = contract.immutableReferences,
      generatedSources = contract.generatedSources,
      deployedGeneratedSources = contract.deployedGeneratedSources,
      db = contract.db;
  return {
    contract_name: contractName,
    sourcePath: sourcePath,
    source: source,
    sourceMap: sourceMap,
    deployedSourceMap: deployedSourceMap,
    legacyAST: legacyAST,
    ast: ast,
    abi: abi,
    metadata: metadata,
    bytecode: forBytecode(bytecode),
    deployedBytecode: forBytecode(deployedBytecode),
    unlinked_binary: forBytecode(bytecode),
    compiler: compiler,
    devdoc: devdoc,
    userdoc: userdoc,
    immutableReferences: immutableReferences,
    generatedSources: generatedSources,
    deployedGeneratedSources: deployedGeneratedSources,
    db: db
  };
}

exports.forContract = forContract;

function forBytecode(bytecode) {
  if (!bytecode) {
    return bytecode;
  }

  if (typeof bytecode === "string") {
    return bytecode;
  }

  var bytes = bytecode.bytes,
      linkReferences = bytecode.linkReferences;
  linkReferences = linkReferences || []; // inline link references - start by flattening the offsets

  var flattenedLinkReferences = linkReferences // map each link ref to array of link refs with only one offset
  .map(function (_ref) {
    var offsets = _ref.offsets,
        length = _ref.length,
        name = _ref.name;
    return offsets.map(function (offset) {
      return {
        offset: offset,
        length: length,
        name: name
      };
    });
  }) // flatten
  .reduce(function (a, b) {
    return [].concat(_toConsumableArray(a), _toConsumableArray(b));
  }, []); // then overwite bytes with link reference

  bytes = flattenedLinkReferences.reduce(function (bytes, _ref2) {
    var offset = _ref2.offset,
        name = _ref2.name,
        length = _ref2.length;
    // length is a byte offset
    var characterLength = length * 2;
    var linkId = "__".concat(name.slice(0, characterLength - 2));

    while (linkId.length < characterLength) {
      linkId += "_";
    }

    var start = offset * 2;
    return "".concat(bytes.substring(0, start)).concat(linkId).concat(bytes.substring(start + characterLength));
  }, bytes);
  return "0x".concat(bytes);
}

exports.forBytecode = forBytecode;